import { createFileRoute } from '@tanstack/react-router';
import { LaneCreate } from '@uturn/portal/modules/lanes/pages/create';

export const Route = createFileRoute('/_protected/lanes/create')({
	component: LaneCreate,
});
